<div class="wrapper-chart">
  @if (dataSet() && dataSet().length) {
    <ngx-charts-area-chart
      [scheme]="colorScheme"
      [showYAxisLabel]="true"
      [xAxis]="true"
      [yAxis]="true"
      yAxisLabel="Conversions"
      [timeline]="timeline()"
      [results]="dataSet()"
      >
    </ngx-charts-area-chart>
  } @else {
    <h2 i18n>There is no data to display</h2>
  }
</div>
<div>
  <strong class="total">Total Conversions: </strong>
  <span> {{ totalConversions() || 0 | number : '1.0-0' }}</span>
</div>
